/* eslint-disable no-console */
import { useMemo } from 'react';

import { useLogger as useCoreLogger } from '@edreamsodigeo/frontend-core';

const getParams = new URLSearchParams(window.location.search);

const isDebug = getParams.get('debug') === 'true';

export const useLogger = () => {
  const debug = useMemo(() => isDebug, []);
  const logger = useCoreLogger();

  const info = (...args) => {
    if (debug) {
      console.info(args);
      logger.info(args.join(' '));
    }
  };

  const error = (...args) => {
    console.error(args);
    logger.error(new Error(args[0]), args.slice(1).join(' '));
  };

  const warn = (...args) => {
    if (debug) {
      console.warn(args);
      logger.warn(args.join(' '));
    }
  };

  return {
    error,
    info,
    warn,
  };
};
